import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { PosUsersMaster } from "./PosUsers/PosUsersMaster";
import { StoreUsersMaster } from "./StoreUsers/StoreUsersMaster";

const UserManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/store`} component={StoreUsersMaster} />
    <Route exact path={`${url}/pos`} component={PosUsersMaster} />
  </Switch>
);

export const UserManagement = withRouter(UserManagementRoutes);
